import { Provider } from 'react-redux';
import { persistor, store } from './app/store';
import { PersistGate } from 'redux-persist/integration/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { UnifiedLoader } from './components/loader';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Provider store={store}>
    <PersistGate loading={<UnifiedLoader fullScreen text="Iniciando aplicación..." />} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,
);

reportWebVitals();

